import { useDeepEqualMemo } from '@superdispatch/hooks';
import { useCallback } from 'react';
import { useCarrierInfo } from 'shared/modules/carrier-profile/data/CarrierInfoAPI';
import { useDispatcherProfile } from 'shared/modules/dispatcher/DispatcherAPI';
import { ShipperProfileDTO } from 'shared/modules/shipper/ShipperProfileDTO';
import { LoadboardEvent, trackLoadboardEvent } from '../../LoadboardAnalytics';

export function useShipperProfileAnalytics(
  shipperProfile: ShipperProfileDTO | undefined,
) {
  const carrierProfileInfo = useCarrierInfo();
  const dispatcherProfile = useDispatcherProfile();

  const analyticsData = useDeepEqualMemo(() => {
    if (
      !shipperProfile ||
      (!carrierProfileInfo.data && !carrierProfileInfo.error) ||
      (!dispatcherProfile.data && !dispatcherProfile.error)
    ) {
      return null;
    }

    return {
      shipper: {
        name: shipperProfile.name,
        email: shipperProfile.contact_email,
        contactName: shipperProfile.contact_name,
        phone: shipperProfile.contact_phone,
      },
      carrier: carrierProfileInfo.data && {
        name: carrierProfileInfo.data.name,
        email: carrierProfileInfo.data.email,
        phone: carrierProfileInfo.data.phone_numbers,
      },
      dispatcher: dispatcherProfile.data && {
        name: dispatcherProfile.data.name,
        email: dispatcherProfile.data.email,
        phone: dispatcherProfile.data.phone,
      },
    } as const;
  }, [carrierProfileInfo, dispatcherProfile, shipperProfile]);

  return useCallback(
    (name: LoadboardEvent['name']) => {
      if (analyticsData) {
        trackLoadboardEvent({ name, ...analyticsData } as LoadboardEvent);
      }
    },
    [analyticsData],
  );
}
